import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { MODAL_TYPE_PRO_MYPAGE_CLIENT, MODAL_TYPE_PRO_MYPAGE_ORDER, MODAL_TYPE_PRO_MYPAGE_REPLY, MODAL_TYPE_PRO_MYPAGE_REVIEW, MODAL_TYPE_PRO_MYPAGE_SEND_OFF, MODAL_TYPE_PRO_MYPAGE_STAFF, showModal, } from '../../../../../../../../actions/ModalActions';
import { apiUpdateProfessionalSolutionOrderMemo } from '../../../../../../../../actions/ProfessionalMySolutionActions';
import { propFunc, propShape, } from '../../../../../../../../helpers/custom-prop-types';
import { isDoneResponse } from '../../../../../../../../helpers/professional_my_page';
import { compose } from '../../../../../../../../helpers/recompose';
import { isEnableOrderChange, isEnableOrderUpdate, isEnableStaffChange, } from '../../../../../../../../helpers/solution';
import DetailAction from '../../../../BodyParts/DetailAction';
import DetailClient from '../../../../BodyParts/DetailClient';
import DetailMemo from '../../../../BodyParts/DetailMemo';
import DetailReplay from '../../../../BodyParts/DetailReply';
import DetailStaff from '../../../../BodyParts/DetailStaff';
const ProfessionalMyPageTopMySolutionItemBodyRow = (props) => {
    const { onClickReview, order, profile, showModalChangeStaff, showModalClient, showModalConfirmOrder, showModalConfirmSendOff, showModalReplay, solution, updateMemo, } = props;
    const isDoneFirst = isDoneResponse(order);
    const isDisabledStaff = !isEnableStaffChange(solution, profile);
    const isDisabledChange = !isEnableOrderChange(solution, order, profile);
    const isDisabledUpdate = !isEnableOrderUpdate(solution, order, profile);
    return (_jsxs("div", Object.assign({ className: `client-detail ${!isDoneFirst ? 'is-need-respond' : null}` }, { children: [_jsx(DetailClient, { order: order, showModalClientDetail: showModalClient, showModalReplay: showModalReplay }), _jsx(DetailReplay, { order: order, showModalReplay: showModalReplay }), _jsx(DetailStaff, { disabled: isDisabledStaff, order: order, profile: profile, showModalChangeStaff: showModalChangeStaff }), _jsx(DetailMemo, { disabled: isDisabledChange, order: order, updateMemo: updateMemo }), _jsx(DetailAction, { disabled: isDisabledUpdate, onClickReview: onClickReview, order: order, showModalConfirmOrder: showModalConfirmOrder, showModalConfirmSendOff: showModalConfirmSendOff })] })));
};
ProfessionalMyPageTopMySolutionItemBodyRow.propTypes = {
    onClickReview: propFunc().isRequired,
    order: propShape().isRequired,
    profile: propShape().isRequired,
    showModalChangeStaff: propFunc().isRequired,
    showModalClient: propFunc().isRequired,
    showModalConfirmOrder: propFunc().isRequired,
    showModalConfirmSendOff: propFunc().isRequired,
    showModalReplay: propFunc().isRequired,
    solution: propShape().isRequired,
    updateMemo: propFunc().isRequired,
};
const mapDispatchToProps = (dispatch, { order, solution }) => ({
    onClickReview: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_REVIEW, order.id, { order, solution }));
    },
    showModalChangeStaff: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_STAFF, order.id, { order, solution }));
    },
    showModalClient: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_CLIENT, order.id, { order, solution }));
    },
    showModalConfirmOrder: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_ORDER, order.id, { order, solution }));
    },
    showModalConfirmSendOff: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_SEND_OFF, order.id, { order, solution }));
    },
    showModalReplay: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_REPLY, order.id, { order, solution }));
    },
    updateMemo: (event) => {
        // value of textarea
        const memo = event.target.value;
        dispatch(apiUpdateProfessionalSolutionOrderMemo(order.id, { memo }));
    },
});
const enhance = compose(connect(null, mapDispatchToProps));
export default enhance(ProfessionalMyPageTopMySolutionItemBodyRow);
